import { Search } from "lucide-react";
import { Input } from "@/v2/components/ui/input";
import type { ContentFilters } from "../schedulerUtils";
import { BARE_CONTROL, Field } from "./parts";

/** The library's search box. Plain text in, text out: whoever owns the
 *  value decides what it searches (games by team, uploads by title), and
 *  both searches run on the backend. */
export function SearchBox({
  value,
  onChange,
  placeholder,
  label,
}: {
  value: string;
  onChange: (text: string) => void;
  placeholder: string;
  label: string;
}) {
  return (
    <Field>
      <Search size={16} className="shrink-0 text-muted-foreground" style={{ marginLeft: 12 }} />
      <Input
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={BARE_CONTROL}
      />
    </Field>
  );
}

interface Props {
  filters: ContentFilters;
  onChange: (next: ContentFilters) => void;
}

/** Games search box, shared by the library and the picker dialog. */
export function ContentFilterBar({ filters, onChange }: Props) {
  return (
    <SearchBox
      label="Search content"
      placeholder="Search by team name"
      value={filters.query}
      onChange={(query) => onChange({ ...filters, query })}
    />
  );
}
